module.exports = __webpack_public_path__ + "img/Theme_mariage.df41e19.png";